<template>
  <div>
    <v-card-text class="mt-2">
      <v-row no-gutters>
        <v-col cols="12" sm="3" class="mr-3">
          <date-range-picker v-model="filter.date" @input="load" dense label="Укажите период С - До" />
        </v-col>
      </v-row>
    </v-card-text>

    <div style="height: 3px" class="w-100">
      <v-progress-linear v-if="loading" color="cyan" indeterminate rounded height="3" />
    </div>

    <v-simple-table fixed-header height="540">
      <thead>
        <tr>
          <th class="text-left" style="max-width: 280px">Параметр</th>
          <th class="text-center" style="max-width: 120px">Текущий</th>
          <th class="text-center" style="max-width: 140px">Норма</th>
          <th class="text-center" style="max-width: 170px">Ед. измерения</th>

          <th class="text-center pa-0" style="max-width: 50px">
            <v-btn elevation="0" outlined icon small @click="prevPeriod" :disabled="!canPrevBtn">
              <v-icon>keyboard_arrow_left</v-icon>
            </v-btn>
          </th>

          <template v-if="theader.length">
            <th class="text-center" v-for="(val, idx) in theader" :key="idx">{{ val }}</th>
          </template>

          <th class="text-center" v-if="!theader.length">{{ currentPeriod }}</th>
          <th class="text-center pa-0" style="max-width: 50px">
            <v-btn elevation="0" outlined icon small @click="nextPeriod" :disabled="!canNextBtn">
              <v-icon>keyboard_arrow_right</v-icon>
            </v-btn>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="param in items" :key="param.id">
          <td class="text-left" style="max-width: 280px">{{ param.name }}</td>
          <td class="text-center" style="max-width: 120px">
            <span :class="{ 'error--text': !checkParamNorms(param) }">{{ param.lval }}</span>
          </td>
          <td class="text-center" style="max-width: 140px">{{ param.nmin }} - {{ param.nmax }}</td>
          <td class="text-center" style="max-width: 170px">{{ param.measure }}</td>
          <td class="text-center" style="max-width: 50px"></td>
          <template v-if="theader.length">
            <td class="text-center" v-for="(val, idx) in theader" :key="`${idx}-${val}-td`">
              <template v-if="param.items[val]">
                <v-btn
                  text
                  color="primary"
                  :disabled="!param.items[val].isManyValue"
                  @click="showParameterForDay(param.items[val], param.name)"
                >
                  <v-icon v-if="param.items[val].isManyValue" small left>mdi-information-outline</v-icon>
                  {{ param.items[val].ival }}
                </v-btn>
              </template>
            </td>
          </template>
          <td v-else class="text-center">-</td>
          <td class="text-center" style="max-width: 50px"></td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import throttle from "lodash/throttle";
import { QueryHelper } from "@/services/query-helper";
import DateRangePicker from "@/components/forms/DateRangePicker";
import ModalParameterInfo from "@/views/pages/parameters/components/ModalParameterInfo";
// TODO: Месяц, Год - неработает бек
const PERIODS = [
  { id: 0, text: "День" },
  { id: 1, text: "Неделя" },
  // { id: 2, text: 'Месяц' },
  // { id: 3, text: 'Год' },
];

export default {
  name: "ParametersList",
  components: { DateRangePicker },
  data: function() {
    return {
      loading: false,
      search: "",
      headers: [
        { text: "Параметр", value: "param" },
        { text: "Текущий", value: "current", align: "center" },
        { text: "Норма", value: "norm", align: "center" },
        { text: "Ед. измерения", value: "unit", align: "center" },
      ],
      filter: {
        period: 0,
        date: [],
        from: "",
        till: "",
        next: 0,
        till_pick: 0,
      },
      periods: PERIODS,
      items: [],
      theader: [],
      gdata: [],

      currentDate: this.$date().format("YYYY-MM-DD"),
      currentPeriod: "",
      noMeasurementsBack: false,
      noMeasurementsForward: false,
      direction: "back",
    };
  },

  computed: {
    customerId() {
      return this.$store.state.customer.id;
    },

    isDirectionBack() {
      return this.direction === "back";
    },

    isDirectionForward() {
      return this.direction === "forward";
    },

    canPrevBtn() {
      if (this.noMeasurementsBack || this.loading) {
        return false;
      }

      return true;
    },

    canNextBtn() {
      if (this.$date().format("YYYY-MM-DD") === this.$date(this.filter.till).format("YYYY-MM-DD")) {
        return false;
      }

      if (this.noMeasurementsForward || this.loading) {
        return false;
      }

      return true;
    },
  },

  watch: {},

  async mounted() {
    await this.load();

    document.addEventListener("keydown", this.hotkeyHandler);
  },

  destroyed() {
    document.removeEventListener("keydown", this.hotkeyHandler);
  },

  methods: {
    async load() {
      this.loading = true;

      const { date, ...filter } = this.filter;

      filter.from = date[0];
      filter.till = date[1];
      filter.period = filter.period || 0;
      //filter.till_pick = filter.till_pick || 1;

      // TODO: думаю это не совсем корректный способ сравнения
      if (date[0] > this.currentDate && this.isDirectionForward) {
        this.noMeasurementsForward = true;
        this.loading = false;
        return;
      }

      try {
        const params = {
          ...QueryHelper.filter(filter),
          //...QueryHelper.tableSorting(this.options),
        };
        console.log(`params =>`, params);

        const response = await this.$http.get(`v1/customers/${this.customerId}/params`, { params }).then(r => r.data);
        this.prepareData(response.theader, response.data);

        // Устанавливает в фильтр значения диапазона
        this.filter.from = response.date_range.from;
        this.filter.till = response.date_range.till;
        this.filter.date = [this.filter.from, this.filter.till];
        this.currentPeriod = `${this.$date(this.filter.from).format("DD/MM")} - ${this.$date(this.filter.till).format("DD/MM")}`;

        // Проверяем или в текущех данных били измерения, если были тогда theader будет не пустым
        if (!this.theader.length) {
          const checkResponse = await this.$http
            .get(`v1/customers/${this.customerId}/params/find-available-date`, {
              params: {
                direction: this.direction,
                from: response.date_range.from,
                order: "asc",
              },
            })
            .then(r => r.data);

          if (checkResponse.success) {
            this.filter.date = [checkResponse.date_from, checkResponse.date_till];
            this.filter.next = 0;
            return await this.load();
          }

          if (this.direction === "back") {
            this.noMeasurementsBack = true;
          }

          if (this.direction === "forward") {
            this.noMeasurementsForward = true;
          }
        }
      } catch (e) {
        // TODO: Обработать ошибку
        console.error(e);
      }

      this.loading = false;
    },

    apiSearch: throttle(async function apiSearchHandler() {
      await this.load();
    }, 1000),

    /**
     * Проверяет параметр на соответствие нормам
     *
     * @param param
     * @return {boolean}
     */
    checkParamNorms(param) {
      if (param.nmax === "" || param.nmin === "") {
        return true;
      }

      return !(param.lval > param.nmax || param.lval < param.nmin);
    },

    /**
     * Подгружает значения параметрова предыдущего периода
     */
    async prevPeriod() {
      this.filter.next--;
      this.direction = "back";
      this.noMeasurementsForward = false;
      await this.load();
    },

    /**
     * Подгружает значения параметрова следующего периода
     */
    async nextPeriod() {
      this.filter.next++;
      this.direction = "forward";
      this.noMeasurementsBack = false;
      await this.load();
    },

    hotkeyHandler(event) {
      if (event.altKey && event.key === "ArrowLeft") {
        event.preventDefault();
        this.prevPeriod();
      }

      if (event.altKey && event.key === "ArrowRight") {
        event.preventDefault();
        this.nextPeriod();
      }
    },

    /**
     * Показывает детальную информацию о измерении за день
     *
     * @param param
     */
    async showParameterForDay(param, name) {
      await this.$dialog.show(ModalParameterInfo, { readonly: true, parameter: param, width: 600, name });
    },

    prepareData(headers, data) {
      const availableHeader = new Set();

      const params = data.map(param => {
        const items = {};

        param.items.forEach(item => {
          if (item.date && item.ival) {
            const dayMonth = this.$date(item.date).format("DD/MM");
            if (headers.includes(dayMonth)) {
              availableHeader.add(dayMonth);
              items[dayMonth] = item;
            }
          }
        });
        param.items = items;

        return param;
      });

      this.theader = Array.from(availableHeader);
      this.items = params;
    },
  },
};
</script>

<style scoped></style>
